import React, { useRef, useState, useContext } from 'react';
import { navigate } from '@reach/router';

import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
// import FormControlLabel from '@material-ui/core/FormControlLabel';
// import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';

import md5 from 'md5';

import Copyright from '../Copyright';
import AuthContext from '../../services/firebase/AuthContext';
import FireDataContext from '../../services/firebase/FireDataContext';
import { all, timestamp } from '../../app/data/validate';

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

const SignUpMember = () => {
  const classes = useStyles();

  const firstNameRef = useRef();
  const lastNameRef = useRef();
  const emailRef = useRef();
  const pwdRef = useRef();

  const [error, setError] = useState('');
  const [waiting, setWaiting] = useState(false);

  const { signup } = useContext(AuthContext);
  const db = useContext(FireDataContext);

  const handleSubmit = (e) => {
    e.preventDefault();
    const path = `invitations/${md5(emailRef.current.value?.toLowerCase())}`;
    db.get({ path })
      .then(invite => {
        if (!invite) {
          setError({ message: 'Sorry - membership is currently by invitation only' });
          return;
        }
        else {
          try {
            const credentials = {
              email: emailRef.current.value,
              password: pwdRef.current.value
            }

            if (!all(invite.roles, invite.organization)) throw new Error(`Invalid invitation: ${JSON.stringify(invite)}`);

            // setWaiting(true);
            signup(credentials)
              .then(({ user }) => {
                (async () => {
                  await db.update({
                    path: `users/${user.uid}`,
                    payload: {
                      name: `${firstNameRef.current?.value} ${lastNameRef.current?.value}`,
                      roles: [...invite.roles],
                      organization: invite.organization,
                      email: credentials.email,
                      uid: user.uid
                    }
                  });
                  await db.update({
                    path,
                    payload: {
                      signedAt: timestamp(),
                      uid: user.uid
                    }
                  });

                })();


                navigate("/");
              })
              .catch(error => {
                setError(error);
              })
          }
          catch (error) {
            setError(error);
          }
          setWaiting(false);
        }
      })
  }

  const SignupForm = () => {
    return (
      <form className={classes.form} onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              inputRef={firstNameRef}
              autoComplete="fname"
              name="firstName"
              variant="outlined"
              required
              fullWidth
              id="firstName"
              label="First Name"
              autoFocus
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              inputRef={lastNameRef}
              variant="outlined"
              required
              fullWidth
              id="lastName"
              label="Last Name"
              name="lastName"
              autoComplete="lname"
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              inputRef={emailRef}
              variant="outlined"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              inputRef={pwdRef}
              variant="outlined"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
            />
          </Grid>
        </Grid>
        {
          error && <Alert variant="filled" severity="error" onClose={() => setError(undefined)} style={{ marginTop: '1rem', marginBottom: '0.5rem' }}><AlertTitle>Sign-Up Problem</AlertTitle>{error.message}</Alert>
        }
        {
          !error &&
          <Button
            disabled={waiting}
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
          >Sign Up
          </Button>
        }
        <Grid container direction="column" spacing={1} >
          <Grid item>
            <Link href="/signin" variant="body2">
              Already have an account? Sign in here
            </Link>
          </Grid>
          <Grid item>
            <Link href="/signup/referrer" variant="body2">
              New Referrer? Sign up here
            </Link>
          </Grid>
        </Grid>
      </form>
    )
  }

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Typography component="h1" variant="h6">The Intermediary Cooperative</Typography>
        <Avatar className={classes.avatar}>
          <PersonAddIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Intermediary Sign Up
        </Typography>
        <SignupForm />
      </div>
      <Box mt={5}>
        <Copyright />
      </Box>
    </Container>
  );

}

export default SignUpMember;